const session = {
    __typename: 'Session',
    token: null,
    codeDeliveryDetails: null,
    currentUser: null,
    expiration: null,
    issuedAt: null,
    isSigningUp: false,
    sessionIsValid: false,
};

// This should probably be called 'webUiState', because it's mostly specific to packages/web.
// We may want to rename it here and elsewhere in the future.
const uiState = {
    __typename: 'UIState',
    currentlyPlayingAudio: null,
    detections: {
        __typename: 'Detections',
        showChart: true,
    },
    activeLogPolls: {
        analyzeTrqkGap: false,
        analyzeTrqkGapChannel: false,
        exportGapAnalysis: false,
        uploadDetections: false,
        uploadStatements: false,
    },
    statements: {
        __typename: 'Statements',
        showUploadHasStarted: false,
        statementId: null,
        unviewedStatements: [],
    },
    tracks: {
        __typename: 'Tracks',
        viewUnmatchedTracksOnly: false,
    },
};

export const initialStates = {
    session,
    uiState,
};
